import { render, staticRenderFns } from "./RowsCount.vue?vue&type=template&id=70f2e10a&"
import script from "./RowsCount.vue?vue&type=script&lang=js&"
export * from "./RowsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports